import { useEffect, useState, useMemo } from "react";
import { BotService } from "../../services/BotService";

function InfoNodeV2({ node, environment }) {

    const [infoNode, setInfoNode] = useState(null)

    const typeNode = useMemo(() => {
        if (!infoNode) return '';

        if (infoNode.is_menu === 1 && infoNode.validation_api === 0) {
            return 'menu';
        }
        if (infoNode.is_menu === 0 && infoNode.validation_api === 0) {
            return 'continuacion_directa';
        }
        if (infoNode.is_menu === 1 && infoNode.validation_api === 1) {
            return 'segmentacion_api';
        }
        if (infoNode.is_menu === 0 && infoNode.validation_api === 1) {
            return 'validacion_api';
        }
    }, [infoNode])

    const messages = useMemo(() => {
        if (!infoNode || !infoNode.message) return [];

        const chunks = infoNode.message.split('|').filter(c => c !== 'LISTA VOICES').map(c => {
            try {
                return JSON.parse(c)
            } catch (error) {
                return c
            }
        });

        return chunks;
    }, [infoNode])

    const messagesError = useMemo(() => {
        if (!infoNode || !infoNode.message_error) return [];

        const chunks = infoNode.message_error.split('|').filter(c => c !== 'LISTA VOICES').map(c => {
            try {
                return JSON.parse(c)
            } catch (error) {
                return c
            }
        });

        return chunks;
    }, [infoNode])

    const renderMessage = (message) => {
         if(typeof message === 'string') return message;


         return (
            <>
                <div className="mb-3">
                    <label className="form-label">Tipo</label>
                    <input type="text" className="form-control form-control-sm" disabled value={message.title || ''} />
                </div>
                <div className="mb-3">
                    <label className="form-label">Mensaje</label>
                    <textarea  className="form-control form-control-sm" rows={4} disabled value={message.body || ''} ></textarea>
                </div>
                <div className="mb-3">
                    <label className="form-label">Título de opciones</label>
                    <input type="text" className="form-control form-control-sm" disabled value={message?.sections?.[0]?.title || ''} />
                </div>

                <div className="mb-3">
                    <label className="form-label">Opciones</label>
                    <div>
                        {message?.sections?.[0]?.rows?.map((k, i) => <span key={i} className="badge bg-soft-primary text-primary me-2 mb-2">{k.title}</span>)}
                    </div>
                </div>

                
                <div className="mb-3">
                    <label className="form-label">Pie de mensaje</label>
                    <input type="text" className="form-control form-control-sm" disabled value={message.footer || ''} />
                </div>

            </>
         )
    }

    useEffect(() => {
        const getNodeInfo = async (id) => {
            const { data } = await BotService.getInfoNodeV2(id, environment);
            // console.log(data)
            setInfoNode(data)
        }

        if (node) {
            getNodeInfo(node.id);
        }
    }, [node])

    return (
        <>
            <div className="card-header">
                <h3 className="card-header-title">Información de nodo</h3>
                <span className="badge bg-danger">Versión depreciada</span>
            </div>
            <div className="card-body">
                <div className="mb-3">
                    <label className="form-label">Nombre</label>
                    <input type="text" className="form-control" disabled value={infoNode?.name_step || ''} />
                </div>

                {
                    infoNode?.key_words && (
                        <>
                            <div className="mb-3">
                                <label className="form-label">Palabras clave</label>
                                <div>
                                    {infoNode?.key_words.map((k, i) => <span key={i} className="badge bg-soft-primary text-primary me-2 mb-2">{k}</span>)}
                                </div>
                            </div>
                        </>
                    )
                }
                <div className="mb-3">
                    <label className="form-label">Tipo</label>
                    <input type="text" className="form-control" disabled value={typeNode} />
                </div>

                <div className="mb-3">
                    <label className="form-label">Mensajes</label>
                    <div>

                        <div className="accordion" id="accordionMessagesV2">
                            {
                                messages?.map( (message, index) => (
                                    <div className="accordion-item" key={index}>
                                        <div className="accordion-header" id={`message-${index}-accordion`}>
                                            <a className="accordion-button" role="button" data-bs-toggle="collapse" data-bs-target={`#message-${index}-collapse`} aria-expanded="true" aria-controls="collapseOne">
                                                { typeof message === 'string' ? 'Texto':  'Lista'  }
                                            </a>
                                        </div>
                                        <div id={`message-${index}-collapse`} className={'accordion-collapse collapse ' + (!index ? 'show': '')}  aria-labelledby={`message-${index}-accordion`}  data-bs-parent="#accordionMessagesV2">
                                            <div className="accordion-body">
                                                { renderMessage(message) }
                                            </div>
                                        </div>
                                    </div>
                                ))
                            }
                            
                        </div>


                    </div>
                </div>

                {
                    (typeNode === 'segmentacion_api' || typeNode === 'validacion_api') && (
                        <>
                            <div className="mb-3">
                                <label className="form-label">URL desarrollo </label>
                                <input type="text" className="form-control" disabled value={infoNode?.url_dev || ''} />
                            </div>
                            <div className="mb-3">
                                <label className="form-label">URL producción </label>
                                <input type="text" className="form-control" disabled value={infoNode?.url_prod || ''} />
                            </div>

                        </>
                    )
                }
                {
                    typeNode === 'menu' && (
                        <>
                            
                            <hr />
                            <div className="mb-3">
                                <label className="form-label"><strong>Acciones de error</strong></label>
                            </div>


                            <div className="mb-3">
                                <label className="form-label">Tipo de mensaje de error </label>
                                <input type="text" className="form-control" disabled value={infoNode?.action_error || ''} />
                            </div>
                            {
                                (infoNode?.action_error === 'close_ticket' || infoNode?.action_error === 'redirect') && (
                                    <>
                                        <div className="mb-3">
                                            <label className="form-label">Categoría</label>
                                            <input type="text" className="form-control" disabled value={infoNode?.extra_error || ''} />
                                        </div>
                                    </>
                                )
                            }

                            {
                                infoNode?.action_error === 'message' && (
                                    <div className="mb-3">
                                        <label className="form-label">Mensaje</label>
                                        <div>
                                            <div className="accordion" id="accordionMessagesErrorV2">
                                                {
                                                    messagesError?.map( (message, index) => (
                                                        <div className="accordion-item" key={index}>
                                                            <div className="accordion-header" id={`message-error-${index}-accordion`}>
                                                                <a className="accordion-button" role="button" data-bs-toggle="collapse" data-bs-target={`#message-error-${index}-collapse`} aria-expanded="true" aria-controls="collapseOne">
                                                                    { typeof message === 'string' ? 'Texto':  'Lista'  }
                                                                </a>
                                                            </div>
                                                            <div id={`message-error-${index}-collapse`} className={'accordion-collapse collapse ' }  aria-labelledby={`message-error-${index}-accordion`}  data-bs-parent="#accordionMessagesErrorV2">
                                                                <div className="accordion-body">
                                                                    { renderMessage(message) }
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))
                                                }
                                                
                                            </div>
                    
                    
                                        </div>
                                    </div>
                                )
                            }
                            

                        </>
                    )
                }
            </div>
        </>
    )
}
export default InfoNodeV2
